import axiosClient from "utils/api";
const URI = "/admin/reasons";

export const getRejectReason = async (payload) => {
  try {
    const response = await axiosClient().request({
      url: URI,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during reject Reason:", error);
    throw error;
  }
};

export const deleteRejectReason = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete reject Reason:", error);
    throw error;
  }
};

export const updateRejectReason = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update reject Reason:", error);
    throw error;
  }
};

export const addRejectReason = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add reject Reason:", error);
    throw error;
  }
};
